import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/clinical-site-qualification")({
  head: () => buildRouteHead("/es/casos-de-exito/clinical-site-qualification", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/cualificacion-acelerada-de-centros-para-la-presentacion-de-ensayos-clinicos", replace: true });
  },
});
